module.exports = __webpack_public_path__ + "static/media/paper_envelope.png?b3c9aa366ddb3010d87af03ab272c42f";